module.exports = __webpack_public_path__ + "img/paso2.8d567fa6.svg";